/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Quick_Action_TitleInputs */

const de_notifications_quick_action_title = /** @type {(inputs: Notifications_Quick_Action_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen`)
};

/** @type {(inputs: Notifications_Quick_Action_TitleInputs) => LocalizedString} */
const en_notifications_quick_action_title = de_notifications_quick_action_title;

/**

* @param {Notifications_Quick_Action_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_quick_action_title = /** @type {((inputs?: Notifications_Quick_Action_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Quick_Action_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notifications_quick_action_title(inputs)
	return en_notifications_quick_action_title(inputs)
});